import { useIns } from '../v2_helper/common';

const queue = [];
export function useLoading() {
  const app = useIns();
  function loading(key = 'def') {
    queue.push(true);
    const { isActive } = app.$q.loading;
    if (!isActive) {
      const find = queue.some(it => it === true)
      if (find) {
        app.$q.loading.show();
      }
    }
  }
  function hide(key = 'def') {
    queue.pop();
    const { isActive } = app.$q.loading;
    if (isActive) {
      const find = queue.length;
      if (!find) {
        app.$q.loading.hide();
        queue.length = 0;
      }
    }
  }
  return { loading, hide }
}

